import React from "react";
import { ProductEditContext } from "../context/productEdit.context";

export default function useProduct() {
  return React.useContext(ProductEditContext);
}
